import { useMemo } from 'react';
import { AnimatePresence, motion } from 'motion/react';

import { useCarousel } from './hooks/useCarousel';
import { useGetParams } from './hooks/useGetParams';
import { useVote } from './hooks/useVote';

import MessagesList from './components/MessagesList/MessagesList';

import logo from './assets/images/logo.png';
import present from './assets/images/present.webp';

import posterDefault from './assets/images/bgPoster.webp';
import bgDefaultVideo from './assets/video/bgVideo.webm';

function App() {
  const { voteState, currentState } = useVote();
  const { showedMessages, winnerMessage, speed } = useCarousel();

  const {
    authorFontSize,
    msgFontSize,
    phoneNumberFontSize,
    bgVideo,
    bgPoster,
  } = useGetParams();

  const prize = useMemo(() => {
    const isCorrect = voteState?.vars.find((v) => v.correct)?.varImgUrl;

    return isCorrect ? isCorrect : present;
  }, [voteState]);

  return (
    <div className="app-wrapper" style={{ '--speed': `${speed}ms` }}>
      <img src={logo} alt="" className="logo" />

      <div className="title">Розыгрыш призов</div>

      <div className="titreBlock">
        <div className="presentBlock">
          <AnimatePresence mode="wait">
            <motion.div
              className="present"
              key={prize}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1, ease: 'easeInOut' }}
            >
              <motion.img
                animate={{
                  rotate: [0, 1, -0.8, 0.6, -0.4, 0.2, -0.2, 0.4, -0.6, 0.8, 0],
                }}
                transition={{
                  rotate: {
                    duration: 8,
                    delay: 1,
                    ease: 'easeInOut',
                    repeat: Infinity,
                  },
                }}
                src={prize}
                alt=""
                className="presentImg"
              />
            </motion.div>
          </AnimatePresence>
        </div>

        <AnimatePresence mode="wait">
          {['S1', 'S2', 'S3'].includes(currentState) && (
            <motion.div
              key="rnd"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
              className="motion"
              style={{ display: 'flex' }}
            >
              (
              <MessagesList
                winId={winnerMessage?.message.id}
                messages={showedMessages}
                authorFontSize={authorFontSize}
                msgFontSize={msgFontSize}
                phoneNumberFontSize={phoneNumberFontSize}
                currentState={currentState}
                speed={speed || 0}
              />
              )
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      {bgVideo && (
        <video
          autoPlay="autoplay"
          muted="muted"
          loop
          poster={bgVideo === '1' ? posterDefault : bgPoster}
          id="bgVideo"
        >
          <source
            src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
            type="video/webm"
          ></source>
        </video>
      )}
      <div id="img-loader" />
    </div>
  );
}

export default App;
